<template>
    <div class="img-wrapper mb-3">
        <img class="img-fluid" :src="src" :alt="title" onerror="this.onerror=null;this.src='/images/default/broken.png'"/>
    </div>
    <div>
        <div class="swiper-container mySwiper" id="product-details-small-img-slider">
            <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(gallery,i) in images" :key="i">
                    <img
                        onerror="this.onerror=null;this.src='/images/default/broken.png'"
                        class="img-fluid cursor-pointer"
                        :src="gallery.src"
                        :alt="gallery.title"
                        @click="src = gallery.src" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DetailGallery',
    props: {
       title: { required: true },
       images: { required: true },
       defaultSrc: { required: true },
    },
    data() {
        return {
            src: this.defaultSrc,
        }
    }
}
</script>
